import { AMEX, JCB, MASTERCARD, VISA } from 'assets'

export const imageCreditCards = {
  VISA: { image: VISA, color: '#0BA5EC' },
  MASTERCARD: { image: MASTERCARD, color: '#FB6514' },
  AMEX: { image: AMEX, color: '#12B76A' },
  JCB: { image: JCB, color: '#7A5AF8' }
}
